module.exports = __webpack_public_path__ + "img/sku.6b0b16a2.svg";